module.exports = __webpack_public_path__ + "trip.com-logo.png?6d8b7bc936e289e6b1793343cab4d372";